export enum SMSGroupAnalyticsEventType {
  AddedViaQuest = 'Added via Quest',
  RemovedViaQuest = 'Removed via Quest',
  AddedManually = 'Added Manually',
  RemovedManually = 'Removed Manually',
  SMSSent = 'SMS Sent',
  CampaignSent = 'Campaign Sent',
  GroupActivated = 'Group Activated',
  GroupDeactivated = 'Group Deactivated'
}

export interface SMSGroupAnalyticsEvent {
  id: string
  type: SMSGroupAnalyticsEventType
  createdAt: Date
  botId: string
  groupId?: string
  groupSlug?: string
  memberId?: string
  memberPhoneNumber?: string
  numberOfMembersSent?: number
  unsent?: number
  campaignName?: string
}
